import { render, staticRenderFns } from "./description-heading.vue?vue&type=template&id=0b3325be"
import script from "./description-heading.vue?vue&type=script&lang=ts"
export * from "./description-heading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b3325be')) {
      api.createRecord('0b3325be', component.options)
    } else {
      api.reload('0b3325be', component.options)
    }
    module.hot.accept("./description-heading.vue?vue&type=template&id=0b3325be", function () {
      api.rerender('0b3325be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/description/description-heading.vue"
export default component.exports